import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.meeting.room');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { KioskContext, MeetingContext, MeetingLocation } from "src/libs/portal/kiosk/context";

@Component({
    selector: 'wiz-portal-meeting-room',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.meeting.room/view.scss */
:host {
  display: block;
}`],
})
export class PortalMeetingRoomComponent implements OnInit, OnDestroy {
    public selectedRoomAction: any = null;
    public timeText: string = '--:--';
    public dateText: string = '';
    public meetingLocation: MeetingLocation | null = null;
    public meetingContext: MeetingContext = { meetingId: '', reservationId: '', meetingTitle: '' };
    public showLocationSelector: boolean = false;

    private clockTimer: any = null;
    private destroyed: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private ref: ChangeDetectorRef) { }

    public roomActions: any[] = [
        { id: 'start', name: '회의 시작', note: '조명과 화면을 회의 모드로 전환' },
        { id: 'seat', name: '자리 안내', note: '예약자와 참석자 좌석 확인' },
        { id: 'call', name: '담당자 호출', note: '방문 목적에 맞는 담당자 연결' },
        { id: 'device', name: '장비 도움', note: '화면, 음향, 케이블 지원 요청' },
        { id: 'parking', name: '주차 등록', note: '방문자 차량 정보 접수' },
        { id: 'visit', name: '방문 기록', note: '입실과 퇴실 기록 확인' }
    ];

    public async ngOnInit() {
        await this.service.init(null as any);
        this.selectedRoomAction = this.initialRoomAction();
        this.meetingLocation = KioskContext.loadMeetingLocation();
        this.meetingContext = KioskContext.loadMeetingContext();
        this.showLocationSelector = !this.meetingLocation;
        this.updateClock();
        this.clockTimer = setInterval(() => this.updateClock(), 1000 * 30);
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.clockTimer) clearInterval(this.clockTimer);
    }

    public onLocationChange(location: MeetingLocation) {
        this.meetingLocation = location;
        this.showLocationSelector = false;
        this.render();
    }

    public closeLocationSelector() {
        if (!this.meetingLocation) return;

        this.showLocationSelector = false;
        this.render();
    }

    public changeMeetingLocation() {
        this.showLocationSelector = true;
        this.render();
    }

    public goHome() {
        this.service.href('/kiosk/main');
    }

    public selectRoomAction(action: any) {
        if (!action) return;

        if (action.id === 'call') {
            this.service.href('/kiosk/staff');
            return;
        }

        this.selectedRoomAction = action;
        this.render();
    }

    private updateClock() {
        const clock = KioskContext.clockText();
        this.timeText = clock.timeText;
        this.dateText = clock.dateText;
        this.render();
    }

    private initialRoomAction() {
        const params = new URLSearchParams(window.location.search);
        const actionId = `${params.get('action') || ''}`.trim();

        return this.roomActions.find((action) => action.id === actionId) || this.roomActions[0];
    }

    private render() {
        if (this.destroyed) return;

        setTimeout(() => {
            if (this.destroyed) return;

            this.ref.detectChanges();
            if (this.service && this.service.inited) this.service.render();
        }, 0);
    }
}

export default PortalMeetingRoomComponent;